import AmpersandSate from 'ampersand-state';
import AttachmentsCollection from "../model2/attachment/attachments";
import {StorageProvider} from "./const/storage";

const Attachments = AmpersandSate.extend({

    props: {
        attachmentsList: {
            type: 'object',
            default: null
        }
    },

    // new
    preview(attachment, attachmentsCollection= false) {
        this.attachmentsList = attachmentsCollection ? attachmentsCollection._models : [attachment];
        this._goTo(attachment.fileType, attachment.fileId, attachment.storageProvider);
    },

    // depricated
    open(type, fileId, storageProvider, attachments){
        this.attachmentsList = attachments ? attachments : null;
        this._goTo(type, fileId, storageProvider);
    },



    _goTo(type, fileId, storageProvider, options) {


        if (storageProvider === StorageProvider.GOOGLE_DRIVE) {
            gd.goTo('a/i/'+storageProvider+'/'+fileId, options);

        } else {
            switch (type) {
                case gd.const.attachment.fileType.IMAGE:
                    gd.goTo('a/i/'+storageProvider+'/'+fileId, options);
                    break;

                default:
                    console.warn("Attachments _goTo: preview is missing");
                    break;
            }
        }

    },

    getPrevAttachment(fileId) {
        const models = _.filter(this.attachmentsList.slice(),
                a=>a.fileType === gd.const.attachment.fileType.IMAGE ||
                    a.storageProvider === gd.const.storageProvider.GOOGLE_DRIVE);
        let index = -1;

        models.map(function(attachment, key){
            if (attachment.fileId === fileId) {
                const prev = key - 1;
                if (prev < 0) index = -1;
                else index = prev;

                return false;
            }
        });

        return index !== -1 ? models[index] : null;
    },

    getNextAttachment(fileId) {
        const models = _.filter(this.attachmentsList.slice(),
            a=>a.fileType === gd.const.attachment.fileType.IMAGE ||
                a.storageProvider === gd.const.storageProvider.GOOGLE_DRIVE);
        let index = -1;

        models.map(function(attachment, key){
            if (attachment.fileId === fileId) {
                const next = key + 1;
                if (next > models.length - 1) index = -1;
                else index = next;

                return false;
            }
        });

        return index !== -1 ? models[index] : null;
    },

    prev(fileId){
        const attachment = this.getPrevAttachment(fileId);
        if (attachment)
            this._goTo(attachment.fileType, attachment.fileId, attachment.storageProvider, {replace:true});
        else
            console.log("Attachments prev: no attachment found");
    },

    next(fileId){
        const attachment = this.getNextAttachment(fileId);
        if (attachment)
            this._goTo(attachment.fileType, attachment.fileId, attachment.storageProvider, {replace:true});
        else
            console.log("Attachments next: no attachment found");
    },

    clear(){
        this.attachmentsList = null;
    }
});

module.exports = Attachments;